import React, { createContext, useContext } from 'react';
import MembershipProductShow from '../components/MembershipProductShow';

const MembershipProductShowContext = createContext();

export function useMembershipProductShowContext() {
  return useContext(MembershipProductShowContext);
}

const MembershipProductShowApp = (props) => (
  <MembershipProductShowContext.Provider value={props}>
    <MembershipProductShow />
  </MembershipProductShowContext.Provider>
);

export default MembershipProductShowApp;
